import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-menu',
  templateUrl: './login-menu.component.html',
  styleUrls: ['./login-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoginMenuComponent implements OnInit {

  isAuthenticated = false;
  usuario: any;

  constructor(private auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {

    this.auth.user$.subscribe(user => {
      this.usuario = user;
      this.isAuthenticated = !!user;
    });

  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/'], {
      replaceUrl: true
    });
  }
}